import createApiClient from '../utils/apiClient';

const getApi = () => createApiClient();

export interface RegisterPayload {
  username: string;
  email: string;
  password: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    username: string;
    email: string;
  };
}

export interface ResetPasswordRequest {
  email: string;
}

export interface ResetPasswordConfirm {
  token: string;
  newPassword: string;
}

const authService = {
  register: async (payload: RegisterPayload): Promise<AuthResponse> => {
    const response = await getApi().post<AuthResponse>('/auth/register', payload);
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const response = await getApi().post<AuthResponse>('/auth/login', payload);
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: (): void => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  requestPasswordReset: async (payload: ResetPasswordRequest): Promise<void> => {
    await getApi().post('/auth/password-reset-request', payload);
  },

  confirmPasswordReset: async (payload: ResetPasswordConfirm): Promise<void> => {
    await getApi().post('/auth/password-reset-confirm', payload);
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('authToken');
  },

  getToken: (): string | null => {
    return localStorage.getItem('authToken');
  },
};

export default authService;
